import { useState, useEffect } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useSnackbar } from 'notistack';
import { useMediaQueryDevice } from 'src/helpers/use';
import { ICPDCourseRound } from 'src/interfaces';

import InfoRoundSelected from './infoRoundSelected';
import { SelectRoundCalendarDialog } from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import SelectionRoundCalendar from '@components/molecules/cpdEnrollment/selectionRoundCalendar';

interface Props {
  opened: boolean;
  close: () => void;
  initialDate?: Date;
  initialSelectRound?: ICPDCourseRound;
  title: string;
  availableRounds: ICPDCourseRound[];
  handleSubmitRound: (newRound: ICPDCourseRound) => void;
  isSameRound: boolean;
  totalCourse?: number;
}

const SelectRoundCalendarModal = ({
  opened,
  close,
  initialDate,
  initialSelectRound,
  title,
  availableRounds,
  handleSubmitRound,
  isSameRound,
  totalCourse,
}: Props) => {
  const { matchesMobile } = useMediaQueryDevice();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const [selectedRound, setSelectedRound] = useState<ICPDCourseRound | undefined>(initialSelectRound);

  const handleRemoveSelectedRound = () => {
    setSelectedRound(undefined);
  };

  const onChangeRound = (round: ICPDCourseRound) => {
    if (selectedRound?.id === round.id) {
      return setSelectedRound(undefined);
    }

    setSelectedRound(round);
  };

  const onSubmit = () => {
    if (selectedRound && !isSameRound) {
      enqueueSnackbar({
        message: t('cpd_enrollment.round.select_round_success', { courseName: title }),
        severity: 'success',
      });
      return handleSubmitRound(selectedRound);
    }
    if (selectedRound && isSameRound) {
      enqueueSnackbar({
        message: t('cpd_enrollment.round.select_group_round_success', { totalCourse }),
        severity: 'success',
      });
      return handleSubmitRound(selectedRound);
    }
    enqueueSnackbar({ message: t('cpd_enrollment.round.please_select_training_round'), severity: 'error' });
  };

  useEffect(() => {
    if (opened) {
      setSelectedRound(initialSelectRound ? { ...initialSelectRound } : undefined);
    } else {
      handleRemoveSelectedRound();
    }
  }, [opened]);

  return (
    <SelectRoundCalendarDialog open={opened} fullScreen={matchesMobile}>
      <FontAwesomeIcon className="close-icon" icon="fa-regular fa-xmark" onClick={close} />
      <Box className="select-round-calendar-box">
        <Box className="select-round-header-box">
          {matchesMobile && <Typography className="title-text">เลือบรอบอบรม</Typography>}
          <Typography className="choose-round-title-text">{title}</Typography>
        </Box>
        <SelectionRoundCalendar
          initialDate={initialDate}
          rounds={availableRounds}
          selectedRound={selectedRound}
          onChangeRound={onChangeRound}
        />
        <InfoRoundSelected selectedRound={selectedRound} handleRemoveSelectedRound={handleRemoveSelectedRound} />
        <Button className="submit-round-button" variant="contained" onClick={onSubmit} fullWidth>
          ยืนยันรอบอบรม
        </Button>
      </Box>
    </SelectRoundCalendarDialog>
  );
};

export default SelectRoundCalendarModal;
